import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

// 1. 引入你需要的组件
import Vant from "vant";
// 2. 引入组件样式
import "vant/lib/index.css";

const app = createApp(App);

//#region 路由拦截
router.beforeEach((to, from, next) => {
  const isMobile =
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent
    ) || false;
  console.log(to);

  if (isMobile) {
    if (to.fullPath === "/login") {
      next();
    } else if (to.fullPath.includes("/login?phone=")) {
      const urlPhone = to.fullPath.substring(13);
      const phone = localStorage.getItem("phone");
      if (phone == urlPhone) {
        let token = localStorage.getItem("token");
        if (token) {
          next({
            path: "/",
          });
        } else {
          next();
        }
      } else {
        next();
      }
    } else {
      let token = localStorage.getItem("token");
      if (token) {
        next();
      } else {
        next({
          path: "/login",
        });
      }
    }
  } else {
    if (to.path != "/mobile") {
      next({
        path: "/mobile",
      });
    } else {
      next();
    }
  }
});

router.afterEach(() => {});
//#endregion

//#region 注册全局对象
app.config.globalProperties.$store = store;
app.config.globalProperties.$router = router;

import { $http } from "@/http";
app.config.globalProperties.$http = $http;

import dayjs from "dayjs";
app.config.globalProperties.$dayjs = dayjs;

//常量对象（存储数据状态）
import constant from "@/utils/constant";
app.config.globalProperties.$constant = constant;
//#endregion

//#region 注入状态模板
import c_status from "@/components/Status.vue";
app.component("c_status", c_status);
//#endregion

//#region 注入金额模板
import c_money from "@/components/Money.vue";
app.component("c_money", c_money);
//#endregion

import { numberFormat, priceFormat, bankAccountFormat } from "@/utils/qFormat";

app.config.globalProperties.$numberFormat = numberFormat;
app.config.globalProperties.$priceFormat = priceFormat;
app.config.globalProperties.$bankAccountFormat = bankAccountFormat;

app.use(store).use(router).use(Vant).mount("#app");
